import { differenceInDays } from 'date-fns/differenceInDays'
import { isToday } from 'date-fns/isToday'
import { startOfDay } from 'date-fns/startOfDay'

import { Tooltip } from '@/components/ui/tooltip.tsx'
import Off from '@/modules/chatting/icons/off.svg'
import On from '@/modules/chatting/icons/on.svg'

interface Props {
  subscribed: boolean
  duration: string | undefined
  renewOn: boolean
  nextPayment?: string | null
}

const formatNextPayment = (nextPayment: string | null | undefined): string => {
  const DateNotSet = 'Next Payment: Not set'

  if (!nextPayment) return DateNotSet

  const paymentDate = startOfDay(new Date(nextPayment))
  const today = startOfDay(new Date())

  if (isToday(paymentDate)) {
    return 'Next Payment: Today'
  }

  const daysDiff = differenceInDays(paymentDate, today)

  if (daysDiff === 1) {
    return 'Next Payment: Tomorrow'
  }

  if (daysDiff > 1) {
    return `Next Payment: In ${daysDiff} days`
  }

  return DateNotSet
}

export const getSubscriptionRows = ({
  subscribed,
  duration,
  renewOn,
  nextPayment,
}: Props) => {
  const DEFAULT_DURATION_ROW = { label: 'Subscribed since', value: 'Today' }

  if (subscribed) {
    return [
      duration
        ? { label: 'Subscribed for', value: duration }
        : DEFAULT_DURATION_ROW,
      {
        label: 'Rebill on',
        value: renewOn ? (
          <Tooltip content={formatNextPayment(nextPayment)}>
            <On />
          </Tooltip>
        ) : (
          <Off />
        ),
      },
    ]
  }

  if (duration) {
    return [{ label: 'Subscribed for', value: duration }]
  }

  return []
}
